module.exports = __webpack_public_path__ + "static/media/github-cli-screenshot.aa2e24ef.png";